import React from 'react';

export const SvgNearMe = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.95 3.738L4.27 9.878c-.83.35-.81 1.53.02 1.85l5.34 2.07a1 1 0 01.57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32z"
      fill="currentColor"
    />
  </svg>
);
